import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5710ac4f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "stake-confirm__header" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "stake-confirm__title" }, "Review and confirm", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "stake-confirm__description" }, " You will be locking your funds for staking. Double check the information and confirm transaction. ", -1))
const _hoisted_4 = {
  key: 0,
  class: "stake-confirm__loading"
}
const _hoisted_5 = {
  key: 1,
  class: "stake-confirm__block"
}
const _hoisted_6 = { class: "stake-confirm__block-item" }
const _hoisted_7 = { class: "stake-confirm__block-item" }
const _hoisted_8 = { class: "stake-confirm__block-item" }

import WhiteWrapper from "@/components/white-wrapper/index.vue";
import ButtonsBlock from "@/components/buttons-block/index.vue";
import BaseButton from "@/components/base-button/index.vue";
import BackButton from "@/components/back-button/index.vue";
import StakeConfirmAmount from "./components/stake-confirm-amount.vue";
import StakeConfirmAccount from "./components/stake-confirm-account.vue";
import StakeConfirmFee from "./components/stake-confirm-fee.vue";
import StakeConfirmValidators from "./components/stake-confirm-validators.vue";
import StakeConfirmProcess from "./components/stake-confirm-process.vue";
import CustomScrollbar from "@/components/custom-scrollbar/index.vue";
import { Account } from "@/types/account";
import {
  ComponentPublicInstance,
  ref,
  onMounted,
  onUnmounted,
  computed,
  watch,
} from "vue";
import { useRouter } from "vue-router";
import {
  accounts,
  apiPromise,
  nativeBalances,
  nativeToken,
  selectedNetwork,
  signer,
  stakingWizardOptions,
} from "@/stores";
import { Validator } from "@/types/staking";
import { GasFeeInfo } from "@/types/transaction";
import { toBN } from "web3-utils";
import { toBase } from "@/utils/units";
import { stakeExtraExtrinsic, stakeExtrinsic } from "@/utils/extrinsic";
import { getGasFeeInfo } from "@/utils/fee";
import { ISubmittableResult } from "@polkadot/types/types";
import { queryHasStash } from "@/utils/staking";


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props, { expose: __expose }) {

const router = useRouter();

const blockScrollRef = ref<ComponentPublicInstance<HTMLElement>>();
const blockRef = ref<ComponentPublicInstance<HTMLElement>>();
const height = ref<number>(0);

const fromAccount = ref<Account>();
const amount = ref<number>(0);
const validators = ref<Array<Validator>>([]);
const isLoading = ref<boolean>(false);
const hasStash = ref<boolean>(false);
const isSend = ref<boolean>(false);
const isSendDone = ref<boolean>(false);
const isError = ref<boolean>(false);
const isCompounding = ref<boolean>(true);

const fee = ref<GasFeeInfo>();

__expose({ blockScrollRef, blockRef });

onMounted(() => {
  window.addEventListener("resize", onResize);
  setTimeout(() => {
    onResize();
  }, 100);

  loadPreviousStakingOptions();
});
onUnmounted(() => {
  window.removeEventListener("resize", onResize);
});

const onResize = () => {
  if (blockRef.value) {
    const topOffset = (blockRef.value as HTMLElement).getBoundingClientRect()
      .top;
    const windowHeight = window.screen.height;
    const bottom = 68;
    const top = 96;

    height.value = windowHeight - (topOffset + bottom + top);
  }
};

const nextAction = async () => {
  if (!fromAccount.value) {
    return;
  }

  isSend.value = true;

  const api = await apiPromise.value;
  const rawAmount = toBN(
    toBase(amount.value?.toString() || "0", nativeToken.value.decimals)
  );

  const tx = await (hasStash.value
    ? stakeExtraExtrinsic(
        api,
        rawAmount.toString(),
        validators.value.map((item) => item.address),
        isCompounding.value
      )
    : stakeExtrinsic(
        api,
        fromAccount.value.address || "",
        rawAmount.toString(),
        validators.value.map((item) => item.address),
        isCompounding.value
      ));

  const unsubscribe = await tx.signAndSend(
    fromAccount.value.address,
    {
      signer: signer.value,
      nonce: -1,
    },
    async (result: ISubmittableResult) => {
      if (!result || !result.status) {
        return;
      }

      if (result.status.isFinalized || result.status.isInBlock) {
        result.events
          .filter(({ event: { section } }) => section === "system")
          .forEach(({ event: { method } }): void => {
            if (method === "ExtrinsicFailed") {
              // Handle error
              isError.value = true;
            } else if (method === "ExtrinsicSuccess") {
              // Handle succes
              isSendDone.value = true;
            }
          });
      } else if (result.isError) {
        // Handle error
        isError.value = true;
      }

      if (result.isCompleted) {
        unsubscribe();
      }
    }
  );
};

const back = () => {
  router.go(-1);
};

const loadPreviousStakingOptions = async () => {
  isCompounding.value = stakingWizardOptions.value.isCompounding;
  if (
    !stakingWizardOptions.value.amount ||
    !stakingWizardOptions.value.fromAccount ||
    !stakingWizardOptions.value.validators
  ) {
    router.replace({
      name: "stake-enter-amount",
    });
    return;
  }
  amount.value = stakingWizardOptions.value.amount;
  fromAccount.value = stakingWizardOptions.value.fromAccount;
  validators.value = stakingWizardOptions.value.validators;
  isLoading.value = true;
  const api = await apiPromise.value;
  hasStash.value = await queryHasStash(api, fromAccount.value.address);
  isLoading.value = false;
};

const availableBalance = computed(() => {
  if (!nativeBalances || !fromAccount.value) {
    return 0;
  }

  return nativeBalances[fromAccount.value.address]?.available.toNumber() || 0;
});

watch([selectedNetwork, accounts], () => {
  router.push({ name: "stake-enter-amount" });
});

watch([amount, nativeBalances], async () => {
  if (!amount.value || !fromAccount.value) {
    return;
  }

  const api = await apiPromise.value;

  const rawAmount = toBN(
    toBase(amount.value?.toString() || "0", nativeToken.value.decimals)
  );

  const tx = await stakeExtrinsic(
    api,
    fromAccount.value?.address || "",
    rawAmount.toString(),
    validators.value.map((item) => item.address),
    isCompounding.value
  );

  fee.value = await getGasFeeInfo(tx, fromAccount.value?.address || "");
});

return (_ctx: any,_cache: any) => {
  const _component_spinner_animation = _resolveComponent("spinner-animation")!

  return (!isSend.value)
    ? (_openBlock(), _createBlock(WhiteWrapper, {
        key: 0,
        class: "stake-confirm__wrap"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(BackButton, { action: back }),
            _hoisted_2
          ]),
          _hoisted_3,
          (isLoading.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createVNode(_component_spinner_animation)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(StakeConfirmAccount, {
                    account: fromAccount.value,
                    title: "From",
                    amount: availableBalance.value
                  }, null, 8, ["account", "amount"])
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(StakeConfirmAmount, {
                    token: _unref(nativeToken),
                    amount: amount.value
                  }, null, 8, ["token", "amount"])
                ]),
                _createElementVNode("div", {
                  ref_key: "blockRef",
                  ref: blockRef,
                  class: "stake-confirm__block-item",
                  style: _normalizeStyle({ maxHeight: height.value + 'px', minHeight: height.value + 'px' })
                }, [
                  _createVNode(CustomScrollbar, {
                    ref_key: "blockScrollRef",
                    ref: blockScrollRef,
                    class: "stake-confirm__scroll-area",
                    style: _normalizeStyle({ maxHeight: height.value + 'px' })
                  }, {
                    default: _withCtx(() => [
                      _createVNode(StakeConfirmValidators, { validators: validators.value }, null, 8, ["validators"])
                    ]),
                    _: 1
                  }, 8, ["style"])
                ], 4),
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(StakeConfirmFee, { fee: fee.value }, null, 8, ["fee"])
                ])
              ])),
          _createVNode(ButtonsBlock, null, {
            default: _withCtx(() => [
              _createVNode(BaseButton, {
                title: `Stake ${_ctx.$filters.cryptoCurrencyFormat(
          amount.value
        )} ${_unref(nativeToken).symbol.toLocaleUpperCase()}`,
                action: nextAction,
                disabled: isLoading.value,
                send: true
              }, null, 8, ["title", "disabled"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }))
    : (_openBlock(), _createBlock(WhiteWrapper, {
        key: 1,
        class: "stake-confirm__wrap"
      }, {
        default: _withCtx(() => [
          _createVNode(StakeConfirmProcess, {
            "is-done": isSendDone.value,
            "is-error": isError.value
          }, null, 8, ["is-done", "is-error"])
        ]),
        _: 1
      }))
}
}

})